import { createPortal } from 'react-dom';

export default function FeedbackRenderer({
  feedback,
}: {
  feedback: string | null;
}) {
  const el = document.getElementById('feedback-root');
  if (!el || !feedback) return null;

  return createPortal(
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-gray-900 text-white px-6 py-3 shadow-lg flex items-center gap-2">
        <i className="ri-check-line text-lg"></i>
        <span className="text-sm font-medium">{feedback}</span>
      </div>
    </div>,
    el
  );
}